module.exports = __webpack_public_path__ + "img/bx-grade-choosings-active.49a7348f.svg";